/* eslint-disable promise/no-callback-in-promise */

import throwUnless from 'tools/throw-unless';
import qs from 'qs';
import { push, replace } from 'react-router-redux';

import paths from 'config/paths';

import ErrorUnauthorized from 'interfaces/error-unauthorised';
import { saveRedirectPage } from 'app/pages/app/app.actions';

function needLogin({ force = false, helmet = {}, useReplace = false, appendQuery } = {}) {
  return async (dispatch, getState) => {
    const state = getState();
    const { currentUser } = state;

    if (!currentUser.id) {
      const { pathname, search } = state.routing.locationBeforeTransitions;

      dispatch(saveRedirectPage({ pathname: `${pathname}${search}`, force, helmet }));

      const method = useReplace ? replace : push;

      const loginUrl = appendQuery ? `${paths.login}?${qs.stringify(appendQuery)}` : paths.login;
      const url = force ? loginUrl : paths.register;

      console.log({ loginUrl, url, force });

      dispatch(method(url));

      throw new ErrorUnauthorized();
    }
  };
}

const checkLogin = (dispatch, callback, options) => {
  const promise = dispatch(needLogin(options));

  if (callback) {
    promise.then(callback).catch(throwUnless([ErrorUnauthorized]));
  } else {
    promise.catch(throwUnless([ErrorUnauthorized]));
  }
};

export default checkLogin;
